import { CustomerService } from '@/services/Customer.service'
import { useTenantOptionalService } from './common/useServiceFactory'
import { useQuery } from '@tanstack/react-query'
import { ViewCustomer } from '@xeetr/types/models'

export function useCustomer(id?: string, initialData?: ViewCustomer) {
  const getService = useTenantOptionalService(CustomerService)

  const customerQuery = useQuery({
    queryKey: ['customer', id],
    queryFn: async () => {
      if (!id) return
      const service = await getService()
      return service.getCustomer(id)
    },
    enabled: !!id,
    initialData,
  })

  return {
    customer: customerQuery.data,
    isLoading: customerQuery.isLoading,
    isError: customerQuery.isError,
    error: customerQuery.error,
    refetch: customerQuery.refetch,
  }
}
